import authsession from './authsession';

const logOrders = ( api, data, setLogData, notifyError, notifyInfo ) => {

    api({
        method: 'post',
        headers: { 'Authorization': authsession() },
        url: 'logsc.php?fun=read&lokacija=porudzbine',
        data: data,
    })
        .then((response) => {

            if (response.data.uspesno) {
                setLogData(response.data);
            } else if (response.data.greska) {
                notifyError(response.data.greska);
            } else if (response.data.info) {
                notifyInfo(response.data.info);
            }
        })
}

export default logOrders